<template>
  <el-container class="login">
    <el-main>
      <div class="shadow" v-if="contactVisible">
        <div>
          <a href="javascript:;" @click.stop='contactHide()'></a>
        </div>
      </div>

      <div class="yblogin_title">
        <img
          class="yblogin_logo"
          src="../assets/images-img/yblogin_logo.png"
          alt=""
          srcset=""
        />
        <p>野豹代理商管理后台</p>
      </div>

      <el-row type="flex" justify="center" id="login" v-if="statusLogin">
        <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="7" class="form-login">
          <el-row type="flex" justify="center">
            <el-col :xs="23" :sm="23" :md="20" :lg="20" :xl="20">
              <!--表单-->
              <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                class="demo-ruleForm"
              >
                <div class="from_title">用户登录</div>
                <el-form-item prop="username" class="username">
                  <el-input
                    style="height:50px"
                    type="text"
                    v-model="ruleForm.username"
                    placeholder="请输入账号或手机号"
                    auto-complete="off"
                    clearable
                  ></el-input>
                  <!-- <template v-if="ruleForm.boolean==false">
                  <el-button @click="getCode()" class="getCode">
                    {{ruleForm.title}}
                  </el-button>
                  </template>
                   <template v-else>
                  <el-button @click="getCode()" class="getCode" disabled>
                    {{ruleForm.title}}
                  </el-button>
                  </template>-->
                </el-form-item>
                <el-form-item prop="password" class="password">
                  <el-input
                    type="password"
                    v-model="ruleForm.password"
                    placeholder="请输入密码"
                    auto-complete="off"
                  ></el-input>
                </el-form-item>
                <div class="btn-group">
                    <div @click="register()">点击注册账号</div>
                    <div @click="contact()">点击联系商务</div>
                </div>
                <el-form-item>
                  <el-button type="primary" @click="submitForm('ruleForm')" style="height:50px;font-size:18px"
                    >登录</el-button
                  >
                </el-form-item>
              </el-form>
              <!--/表单-->
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-main>

    <!-- 注册的弹出框 -->
    <el-dialog class="regdalmo" :visible.sync="dialogVisible" width="680px">
      <div class="title_box">
        <div class="registers">一级代理注册申请</div>
        <div class="day_time">1-3个工作日审核，如有疑问请联系管理员</div>
      </div>

      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="用户昵称:" class="label_name">
          <el-input
            v-model="form.agent_name"
            maxlength="20"
            placeholder="账号为4-20位数字或字母，不能包含空格下划线等特殊符号和标点"
          ></el-input>
        </el-form-item>

        <el-form-item label="手机号:" class="label_name">
          <el-input
            v-model="form.phone"
            placeholder="请输入手机号码"
            maxlength="11"
            oninput="value=value.replace(/[^\d]/g,'')"
          ></el-input>
        </el-form-item>

        <el-form-item label="短信验证:" class="label_name">
          <el-col :span="16">
            <el-input
              v-model="form.code"
              placeholder="请输入短信验证码"
              oninput="value=value.replace(/[^\d]/g,'')"
            ></el-input>
          </el-col>

          <el-button
            type="primary"
            v-if="stateTiem"
            class="verificationCode"
            @click="sendCode()"
            >点击发送验证码</el-button
          >

          <el-button
            style="background: #cecece; color: #525252; border: 0"
            type="primary"
            v-if="!stateTiem"
            class="verificationCode"
            >{{ count }}s</el-button
          >
        </el-form-item>

        <el-form-item label="设置密码:" class="label_name">
          <el-input
            type="password"
            v-model="form.password"
            placeholder="密码为6-20位"
            maxlength="20"
          ></el-input>
        </el-form-item>

        <el-form-item label="确认密码:" class="label_name">
          <el-input
            type="password"
            v-model="confirmPwd"
            placeholder="请再次输入密码"
            maxlength="20"
          ></el-input>
        </el-form-item>

        <el-form-item label="申请理由:" class="label_name">
          <el-input
            type="textarea"
            :rows="5"
            v-model="form.reason"
            placeholder="请认真填写您的申请理由，否者后台将无法审核通过"
          ></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary"  @click="submit()" style="width: 119px;height:50px;font-size:16px"
          >提交申请</el-button
        >
        <el-button
          @click="reset()"
          style="border:1px solid #5C9FFF;background:#ECF5FF;width:119px;height:50px;font-size:16px"
          >重置</el-button
        >
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
import * as sysApi from "../common/sys";
import { setToken } from "@/utils/auth";
import types from "@/store/mutation-types";
import { mapMutations } from "vuex";
//import md5 from 'js-md5';
export default {
  name: "Login",
  data() {
    return {
      ruleForm: {
        username: "",
        password: "",
        boolean: false,
        title: "获取验证码",
      },
      stateTiem: true,
      confirmPwd: "",
      count: "",
      dialogVisible: false,
      contactVisible: false,
      form: {
        agent_name: "",
        phone: "",
        code: "",
        password: "",
        reason: "",
      },
      countdown: "",
      count: 60,
      rules: {
        username: [{ required: true, message: "请输入账号", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      statusLogin: true,
    };
  },
  created() {
    this.nopassWordLogin();
    let that = this;
    document.onkeypress = function (e) {
      var keycode = document.all ? event.keyCode : e.which;

      if (keycode == 13) {
        that.submitForm("ruleForm"); // 登录方法名
        return false;
      }
    };
  },
  methods: {
    nopassWordLogin() {
      var agent_number = this.$route.query.agent_number
        ? this.$route.query.agent_number
        : "";
      var crypt = this.$route.query.crypt ? this.$route.query.crypt : "";

      if (agent_number!='' && crypt !='') {
          this.statusLogin = false;
        var rul = decodeURI(crypt).replace(/ /g,"+",)
        var parms = {
           agent_number: this.$route.query.agent_number,
           crypt:rul
        };

        sysApi.noPasswordLogin(parms).then(res => {
          if (res.code != 1) {
            this.statusLogin = true;
            this.$router.push({ path: "login" });
            return this.$message.error(res.result);
          }
          setToken(res.token);
          this.$store.dispatch("LoginBySetTooken", res.token);
          localStorage.setItem("agent_name", res.result.agent_name);
          localStorage.setItem("agent_phone", res.result.agent_phone);
          localStorage.setItem("agent_status", res.result.agent_status);
          localStorage.setItem("agent_type", res.result.agent_type);
          localStorage.setItem("account_number", res.result.account_number);
          localStorage.setItem("manage_name", res.result.manage_name);
          localStorage.setItem("manage_phone", res.result.manage_phone);
          localStorage.setItem("agent_number", res.result.agent_number);
          this.$router.push({ path: "/" });
          return this.$message.success("登录成功");
        });
      }
    },
    /**登录功能**/
    submitForm(ruleForm) {
      this.$refs[ruleForm].validate((valid) => {
        if (valid) {
          var pa = {
            account: this.ruleForm.username,
            password: this.ruleForm.password,
          };
          sysApi.login(pa).then((res) => {
            if (res.code != 1) {
              return this.$message.error(res.result);
            }
            console.log(res);
            setToken(res.token);
            this.$store.dispatch("LoginBySetTooken", res.token);
            localStorage.setItem("agent_name", res.result.agent_name);
            localStorage.setItem("agent_phone", res.result.agent_phone);
            localStorage.setItem("agent_status", res.result.agent_status);
            localStorage.setItem("agent_type", res.result.agent_type);
            localStorage.setItem("account_number", res.result.account_number);
            localStorage.setItem("manage_name", res.result.manage_name);
            localStorage.setItem("manage_phone", res.result.manage_phone);
            localStorage.setItem("agent_number", res.result.agent_number);
            localStorage.setItem("agent_money", res.result.monthly_recharge_price)
            localStorage.district = res.result.district;
            setTimeout(() => {
              window.location.href = "/";
            }, 1500);
            return this.$message.success("登录成功");
          });
        } else {
          this.$message.error("请输入账号或密码！");
          return false;
        }
      });
    },
    // 注册
    register() {
      this.dialogVisible = true;
    },
    // 联系商务
    contact() {
      this.contactVisible = true;
    },
    contactHide() {
      this.contactVisible = false;
    },
    // 提交表单
    submit() {
      if (this.getFormJudge()) {
        sysApi.submit(this.form).then((res) => {
          if (res.code != 1) {
            return this.$message.error(res.result);
          } else {
            this.dialogVisible = false;
            return this.$message.success(res.result);
          }
        });
      }
    },
    // 发送验证码
    sendCode() {
      if (this.form.phone == "") {
        return this.$message.success("手机号不能为空！");
      }
      if (this.form.phone.length !== 11) {
        return this.$message.success("请输入正确的手机号！");
      }
      const arrPhone = this.form.phone.slice(",");
      if (arrPhone[0] !== "1") {
        return this.$message.success("请输入正确的手机号");
      }
      const params = { phone: this.form.phone };
      const phone = this.$qs.stringify(params);
      sysApi.apply_code(phone).then((res) => {
        if (res.code != 1) {
          return this.$message.error(res.result);
        } else {
          this.$message.success("获取验证码成功！");
          const time = 60;
          if (!this.timer) {
            this.count = time;
            this.stateTiem = false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= time) {
                this.count--;
              } else {
                this.stateTiem = true;
                clearInterval(this.flay);
                this.timer = null;
              }
            }, 1000);
          }
        }
      });
    },
    // 重置
    reset() {
      if (Object.keys(this.form).length !== 0) {
        this.form = {};
      }
    },

    getFormJudge() {
      if (this.form.agent_name.trim() == "") {
        this.$message.error("用户昵称不能为空");
        return false;
      }
       if (this.form.agent_name.length<4) {
        this.$message.error("用户昵称小于4位");
        return false;
      }
      if (this.form.phone == "") {
        this.$message.error("手机号不能为空");
        return false;
      }

      if (this.form.phone.length !== 11) {
        this.$message.error("请输入正确的手机号");
        return false;
      }
      const arrPhone = this.form.phone.slice(",");
      if (arrPhone[0] !== "1") {
        this.$message.error("请输入正确的手机号");
        return false;
      }

      if (this.form.code == "") {
        this.$message.error("请输入验证码");
        return false;
      }

      if (this.form.password == "") {
        this.$message.error("请输入密码");
        return false;
      }
      if (this.form.password !== this.confirmPwd) {
        this.$message.error("密码输入不相同，请重新输入");
        return false;
      }
      if (this.form.reason.trim() == "") {
        this.$message.error("请输入申请理由");
        return false;
      }
      return true;
    },
    GetRequest() {
      var url = decodeURI(location.search); //获取url中"?"符后的字串
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        var str = url.substr(1);
        var strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
        }
      }
      return theRequest;
    },
    ...mapMutations({
      setToken: types.setToken,
    }),
  },
  mounted() {
    if (this.GetRequest().account && this.GetRequest().password) {
      this.ruleForm.username = this.GetRequest().account;
      this.ruleForm.password = this.GetRequest().password;
      var pa = {
        account: this.ruleForm.username,
        password: this.ruleForm.password,
      };
      sysApi.Login(pa).then((res) => {
        console.log(res);
        if (res.success == true) {
          setToken(res.token);
          this.$store.dispatch("LoginBySetTooken", res.token);
          this.$message({
            type: "success",
            message: res.info,
          });
          localStorage.setItem("agent_name", res.data.agent_name);
          localStorage.setItem("agent_status", res.data.agent_status);
          localStorage.setItem("agent_type", res.data.agent_type);
          localStorage.setItem("account_number", res.data.account_number);
          this.$router.push({ path: "/" });
        }
      });
    }

    console.log(this.GetRequest().user, this.GetRequest().password);
  },
};
</script>

<style lang="scss" scoped>
.verificationCode {
  width: 170px;
  margin-left: 15px;
  height: 50px;
  font-size: 16px;
}
.login .el-form-item:last-child {
  margin-top: 0px !important;
}
.registers {
  color: #535353;
  font-size: 22px;
  font-weight: bold;
}
.title_box {
  text-align: center;
  padding-top: 10px;
  padding-bottom: 30px;
}
.day_time {
  color: #409eff;
  font-size: 14px;
  padding-top: 20px;
  font-weight: bold;
}
.btn-group {
  display: flex;
  justify-content: space-between;
  margin-bottom: 53px;
  text-align: center;
  font-size: 14px;
  color: #409eff;

  > div {
    cursor: pointer;
  }
}

.h_title {
  text-align: center;
  font-size: 30px;
  margin-top: 100px;
  color: #fff !important;
}
.login .el-button {
  padding: 12px 0 !important;
}
.el-container {
  height: 100%;
  /* background: #324157; */
  background: url("../assets/images-img/yblogin_back.png") no-repeat;
  background-size: cover;
  width: 100%;
  position: relative;
  .yblogin_title {
    display: flex;
    position: absolute;
    top: 183px;
    left: 360px;
    p {
      font-size: 22px;
      color: #fff;
      height: 45px;
      line-height: 45px;
      border-left: 1px solid #fff;
      padding-left: 30px;
      margin-left: 34px;
      margin-top: 7px;
    }
  }
  .yblogin_logo {
    width: 431px;
    height: 59px;
  }
}
.username .el-input {
  width: 100%;
  float: left;
}
.getCode {
  width: 30%;
  float: left;
}

.login input:-webkit-autofill {
  background: #fff !important;
}
.login .el-form-item__content {
  margin-bottom: 20px;
}
.form-login {
  background: rgba(255, 255, 255, 0.7);
  border-radius: 5px;
  width: 425px;
  height: 450px;
  background-color: #fff;
  border-radius: 3px;
  position: absolute;
  right: 400px;
  top: 280px;
  .from_title {
    line-height: 1;
    margin-bottom: 48px;
    font-weight: 400;
    color: #5c5c5c;
    font-size: 20px;
  }
  .username {
    margin-bottom: 40px !important;
  }
  // 修改点：使用 ::v-deep 替换 /deep/
  ::v-deep .el-input__inner {
    height: 50px !important;
    background-color: #F5F5F5;
    border: 1px solid #DDDDDD;
    color: #999999;
  }
  .password {
    margin-bottom: 23px !important;
  }
}
.regdalmo {
  .el-form-item {
    margin-bottom: 20px !important;
  }
  // 修改点：使用 ::v-deep 替换 /deep/
  ::v-deep .el-input__inner {
    height: 50px !important;
    background-color: #F5F5F5;
    border: 1px solid #DDDDDD;
    color: #999999;
  }
}
.form-login > .el-row {
  margin-bottom: 25px;
}

.form-login > .el-row:last-child {
  margin-top: 40px;
}

.form-login > h2 {
  text-align: center;
  font-weight: normal;
  margin: 20px 0 30px;
}

.login .el-form-item:last-child {
  text-align: center;
  margin-top: 50px;
}

.login .el-form-item:last-child button {
  width: 100%;
}
.label_name {
  font-weight: bold;
}
.el-dialog__wrapper {
  overflow: hidden;
}
.el-dialog__body {
  padding: 0px 20px;
}

.shadow {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 99999;

  div {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 800px;
    height: 600px;
    background: url(https://cdn-js.yebaojiasu.com/netbar/contact-us.png) center top
      no-repeat;

    a {
      display: block;
      width: 41px;
      height: 41px;
      background: url(https://cdn-js.yebaojiasu.com/wb/edg-close.png) left top
        no-repeat;
      position: absolute;
      top: 10px;
      right: 10px;
    }
  }
}
</style>